import { Routes } from '@/routes';

export default {
	'category.show': () => import('@/modules/category/form'),
	'category.new': () => import('@/modules/category/form'),
	'category.index': () => import('@/modules/category/index'),
} as Routes;
